import {get} from "lodash"

import API from "@irati/utils/services/API"
import {generatePutOverrideObject} from "@irati/insights/helpers/question"

import endpoints from "../endpoints"
import {mutateQuestionForV2, mutateQuestionListForV2} from "../utils"

/**
 * List all questions with overrides
 *
 * @param tenantId {string}
 * @returns {Promise<T> | Promise<*> | * | PromiseLike<T>}
 */
export const getQuestionsWithOverrides = (tenantUuid) => {
  return API.get(endpoints.questionsOverrides(tenantUuid)).then(({data}) => data.data)
}

/**
 * Update question overrides
 *
 * @param tenantId
 * @param question
 * @param text
 * @returns {Promise<T> | Promise<*> | * | PromiseLike<T>}
 */
export const overrideQuestion = (tenantId, question, text) => {
  const origText = get(question, "original.text")
  const endpoint = endpoints.updateQuestionsOverrides(get(question, "original.uuid", get(question, "uuid")), tenantId)

  if (origText === text) {
    return API.delete(endpoint, question.Etag)
  }

  return API.put(endpoint, generatePutOverrideObject(tenantId, question, text), question.Etag)
}

export const getQuestions = () => {
  const params = {
    ignoreOverrides: "yes"
  }
  return API.get(endpoints.questions(), {params})
    .then(({data}) => data.data)
    .then((questions) => mutateQuestionListForV2(questions))
}

export const fetchQuestion = (uuid) => {
  const params = {
    ignoreOverrides: "yes"
  }
  return API.get(endpoints.question(uuid), {params})
    .then(({data}) => data)
    .then((question) => mutateQuestionForV2(question))
}

export const updateQuestion = (questionUuid, data) => {
  const {id, uuid, ...formattedData} = data
  return API.put(endpoints.question(questionUuid), formattedData, data.Etag).then(({data: response}) => response)
}
